<form [formGroup]="fileForm" (ngSubmit)="submit(fileForm.valid)" class="esa-form">
  <mat-dialog-content>
    <div class="form-wrapper full">
      <p class="form-heading">{{ 'caseManagement.fileUpload.fileDescription' | translate }}</p>
      <mat-form-field class="esa-form-field">
        <mat-label>{{ 'caseManagement.fileUpload.fileDescription' | translate }}</mat-label>
        <input id="fileDescription" formControlName="fileDescription" matInput>
        <mat-error *ngIf="fileForm.controls.fileDescription.invalid">{{ 'caseManagement.fileUpload.fileDescriptionError' | translate }}</mat-error>
      </mat-form-field>
    </div>

    <div class="form-wrapper full">
      <p class="form-heading">{{ 'caseManagement.fileUpload.selectFile' | translate }}</p>
      <input type="file" class="file-input default-btn" (change)="onFilechange($event)" accept=".pdf,.docx,.xlsx,.pptx,.jpg,.jpeg,.png,.tiff,.tif,.zip" #fileUpload>
    </div>

    <div class="duplicate-warning-card" *ngIf="showActionChoice">
      <div class="warning-header">
        <mat-icon class="warning-icon">warning_amber</mat-icon>
        <div class="warning-titles">
          <h4>Duplicate File Detected</h4>
          <p>A document with this filename is already attached. Choose how you want to proceed:</p>
        </div>
      </div>

      <mat-radio-group formControlName="documentAction" class="action-radio-group">
        <mat-radio-button value="replace" class="action-radio">
          <span class="radio-label-title">Replace existing document</span>
          <span class="radio-label-sub">Overwrite the content and details of the attached file</span>
        </mat-radio-button>

        <mat-radio-button value="append" class="action-radio">
          <span class="radio-label-title">Append to existing document</span>
          <span class="radio-label-sub">Append this file's content to the end of the existing file</span>
        </mat-radio-button>

        <mat-radio-button value="new" class="action-radio">
          <span class="radio-label-title">Keep as new document</span>
          <span class="radio-label-sub">Upload as a separate file alongside the existing document</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <!--  <div class="flex-wrapper">-->
    <!--    <div class="form-wrapper half">-->
    <!--      <p class="form-heading">{{ 'caseManagement.fileUpload.targetFIU' | translate }}</p>-->
    <!--      <mat-form-field class="esa-form-field">-->
    <!--        <mat-label>{{ 'caseManagement.fileUpload.fiu' | translate }}</mat-label>-->
    <!--        <mat-select formControlName="fiuId">-->
    <!--          <mat-option>{{ 'caseManagement.fileUpload.selectFIU' | translate }}</mat-option>-->
    <!--          <mat-option *ngFor="let fiu of fius" [value]="(link unavailable)">-->
    <!--            <span class="country fi fis" [ngClass]="fiu.logo"></span>-->
    <!--            {{fiu.fiuName}}-->
    <!--          </mat-option>-->
    <!--        </mat-select>-->
    <!--      </mat-form-field>-->
    <!--    </div>-->
    <!--  </div>-->
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="">
      <mat-icon>cancel</mat-icon>
      {{ 'shared.cancel' | translate }}
    </button>
    <button mat-button class="submit" [ngClass]="{'valid' : fileForm.valid}" type="submit">
      <mat-icon>upload</mat-icon>
      {{ 'shared.upload' | translate }}
    </button>
  </mat-dialog-actions>
</form>
